<div style="width: 400px; height: fit-content;" data-cy="patient-checkin-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="patient-checkin-header-section">
      <div class="section-header-title" data-cy="patient-checkin-title-text">
        Patient Check-In
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="patient-checkin-content-section">
      <div style="margin-bottom: 10px; font-weight: 500; color: var(--tdo-primary);" data-cy="patient-checkin-patient-name">{{data.PatientName}}</div>
      <div style="display: flex; width: 100%;" data-cy="patient-checkin-mark-container">
        <div style="flex: 1;"></div>
        <mat-checkbox style="margin-right: 4px; flex-basis: fit-content;" [(ngModel)]="isMarkPatientAsCheckedIn" labelPosition="before" data-cy="patient-checkin-mark-checkbox">Mark Patient as Checked In</mat-checkbox>
      </div>
      <div style="display: flex; width: 100%;" data-cy="patient-checkin-xray-container">
        <div style="flex: 1;"></div>
        <div data-cy="patient-checkin-xray-text">Enter X-Rays Received</div>
        <div style="margin-left: 8px; cursor: pointer; color: var(--tdo-primary-accent);" (click)="onOpenUploadAppointmentDocsDialog()" data-cy="patient-checkin-upload-button"><mat-icon>cloud_upload</mat-icon></div>
      </div>
      <div *ngIf="uploadedItems.length > 0" style="font-weight: 500; margin-top: 20px;" data-cy="patient-checkin-uploaded-section">
        <span data-cy="patient-checkin-uploaded-title">Uploaded Documents</span>
        <div style="max-height: 100px; border-radius: var(--border-radius); border: 2px solid var(--tdo-primary-accent); padding: 3px; color: black; font-size: 12px; font-weight: 500; overflow-y: auto;" data-cy="patient-checkin-uploaded-list">
          <div *ngFor="let item of uploadedItems" data-cy="patient-checkin-uploaded-item">
            <div (click)="openDoc(item)" style="cursor: pointer; color: var(--tdo-primary);" *ngIf="item.DocFrom && item.DocFrom.length > 0" data-cy="patient-checkin-doc-with-from">
              {{item.OriginalFileName}} {{item.DocFrom}} {{getDate(item.xauditCreatedOn)}}
            </div>
            <div (click)="openDoc(item)" style="cursor: pointer; color: var(--tdo-primary);" *ngIf="!item.DocFrom || (item.DocFrom && item.DocFrom.length === 0)" data-cy="patient-checkin-doc-without-from">
              {{item.OriginalFileName}} {{getDate(item.xauditCreatedOn)}}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="unsignedForms?.length > 0" style="font-weight: 500; margin-top: 20px;" data-cy="patient-checkin-unsigned-section">
        <span style="color: red;" data-cy="patient-checkin-unsigned-action">Action required:</span> <span data-cy="patient-checkin-unsigned-title">Unsigned forms:</span>
        <div style="max-height: 100px; overflow-y: auto; border: 2px solid orange; border-radius: var(--border-radius); padding: 3px;" data-cy="patient-checkin-unsigned-list">
          <mat-table [dataSource]="unsignedForms" class="mat-elevation-z8" data-cy="patient-checkin-unsigned-table">
            <ng-container matColumnDef="date">
              <mat-cell *matCellDef="let form" class="date-cell" data-cy="patient-checkin-form-date">
                {{ form?.xauditCreatedOn | date: 'MM/dd/yyyy' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="description">
              <mat-cell *matCellDef="let form" class="description-cell" data-cy="patient-checkin-form-description">
                {{ form?.Description }}
              </mat-cell>
            </ng-container>
            <mat-row *matRowDef="let row; columns: ['date', 'description'];" data-cy="patient-checkin-form-row"></mat-row>
          </mat-table>
        </div>
      </div>
      
      <div *ngIf="unsignedForms.length > 0" style="font-size: 12px; margin-top: 20px; display: flex;" data-cy="patient-checkin-portal-section">
        <div style="flex: 1;" data-cy="patient-checkin-portal-info">
          There are forms that require filling / signature.<br />Use tablet with patient portal.
          <div style="flex: 1;" data-cy="patient-checkin-login-code">Login Code: <span style="font-weight: 500; color: var(--tdo-primary);" data-cy="patient-checkin-code-value">{{loginCode}}</span></div>
        </div>
        <div data-cy="patient-checkin-qrcode"><qr-code [value]="getQRCode()"></qr-code></div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 40px;" data-cy="patient-checkin-footer-section">
      <button (click)="openPatient()" class="tdo-button tdo-save" style="margin-left: 6px; margin-right: 6px;" data-cy="patient-checkin-open-button">Open Patient</button>
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="patient-checkin-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="patient-checkin-ok-button">Ok</button>
    </div>
  </div>
</div>
